<template>
    <div class="overlay">
      <div class="onboarding-checkout-modal">
        <img src="@/assets/images/onboarding_checkout_modal.png" class="background-img" alt="background-img" />
        <div class="modal-content">
          <div class="modal-title">
            Boom!
          </div>
          <div class="modal-description">
            We’ve got great news, {{ firstName }}. Your Voyyp account has been created! Let’s get you dialed in. First,
            let’s name {{ selectedNumber }}
          </div>
          <form class="modal-row" novalidate @submit.prevent="$emit('on-next', name)">
            <input-field
              ref="name"
              v-model="name"
              name="name"
              placeholder="ex “Company’s Main Line”"
              custom-style="width: 375px;"
            />
            <custom-button custom-style="margin-left: 5px; width: 190px;" :disabled="!name || isLoading" type="submit">
              Next >
            </custom-button>
          </form>
          <div class="modal-notification">We’ve emailed your order summary (confirmation #XXX-XXX) to {{ email }}.</div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import InputField from '@/components/InputField';
  import CustomButton from '@/components/CustomButton';
  
  export default {
    name: 'OnboardingCheckoutModal',
    components: {
      CustomButton,
      InputField
    },
    props: {
      email: String,
      firstName: String,
      isLoading: Boolean,
      selectedNumber: String
    },
    data() {
      return {
        name: 'Main Line'
      };
    },
    mounted() {
      this.$refs.name.focus();
    },
  };
  </script>
  
  <style scoped lang="scss">
  .onboarding-checkout-modal {
    position: relative;
    width: 850px;
    height: 450px;
    background-color: $colorBack;
    border-radius: 10px;
  
    .background-img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
    }
  
    .modal-content {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  
    .modal-title {
      margin-top: 100px;
      font-weight: 800;
      font-size: 40px;
      line-height: 48px;
      text-align: center;
      letter-spacing: -0.5px;
      color: $colorTitle;
    }
  
    .modal-description {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 0.1px;
      color: $colorText;
      margin: 5px 163px;
    }
  
    .modal-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 40px;
    }
  
    .modal-notification {
      position: absolute;
      bottom: 5px;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 0.1px;
      color: $colorPlaceholder;
    }
  }
  </style>
